import { render, staticRenderFns } from "./VerifyEmail.vue?vue&type=template&id=1dbccb99&scoped=true&"
import script from "./VerifyEmail.vue?vue&type=script&lang=ts&"
export * from "./VerifyEmail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbccb99",
  null
  
)

export default component.exports